<template>
    <ul class="patent-list-toggle">
        <!--previous-->
        <ELTooltip
            :visibleArrow="false"
            :openDelay="popperOpenDelay"
            popperClass="patent-list-toggle__tooltip-container"
            placement="left"
            effect="dark"
        >
            <li
                id="hot-key-patents-list-previous"
                :class="['patent-list-toggle__item', { 'patent-list-toggle__item--disabled': disablePre }]"
                @click="togglePre"
            >
                <PtIcon icon="SolidArrowUp" />
            </li>
            <div slot="content" v-addIframe class="patent-list-toggle__tooltip">
                <span class="patent-list-toggle__tooltip-text">{{ $t('highlight.Previous') }}</span>
                <template v-for="key in hotKeyMap.previous">
                    <span :key="`previous-${key}-tooltip-tip`" class="patent-list-toggle__tooltip-tip">{{ key }}</span>
                    <span :key="`previous-${key}-tooltip-and`" class="patent-list-toggle__tooltip-and">+</span>
                </template>
            </div>
        </ELTooltip>
        <!--next-->
        <ELTooltip
            :visibleArrow="false"
            :openDelay="popperOpenDelay"
            popperClass="patent-list-toggle__tooltip-container"
            placement="left"
            effect="dark"
        >
            <li
                id="hot-key-patents-list-next"
                :class="['patent-list-toggle__item', { 'patent-list-toggle__item--disabled': disableNext }]"
                @click="toggleNext"
            >
                <PtIcon
                    icon="SolidArrowDown"
                />
            </li>
            <div slot="content" v-addIframe class="patent-list-toggle__tooltip">
                <span class="patent-list-toggle__tooltip-text">{{ $t('highlight.Next') }}</span>
                <template v-for="key in hotKeyMap.next">
                    <span :key="`next-${key}-tooltip-tip`" class="patent-list-toggle__tooltip-tip">{{ key }}</span>
                    <span :key="`next-${key}-tooltip-and`" class="patent-list-toggle__tooltip-and">+</span>
                </template>
            </div>
        </ELTooltip>
        <!--collapes-->
        <ELTooltip
            ref="patentsListCollapes"
            :visibleArrow="false"
            :openDelay="popperOpenDelay"
            popperClass="patent-list-toggle__tooltip-container"
            placement="left"
            effect="dark"
        >
            <li
                id="hot-key-patents-list-collapes"
                :class="['patent-list-toggle__item', { 'patent-list-toggle__item--disabled': disableCollapes }]"
                @click="toggleCollapes"
            >
                <PtIcon
                    :icon="!isCollapsed ? 'SolidDropdownRight' : 'SolidDropdownLeft'"
                />
            </li>
            <div slot="content" v-addIframe class="patent-list-toggle__tooltip">
                <span class="patent-list-toggle__tooltip-text">{{ !isCollapsed ? $t('highlight.Collapes') : $t('highlight.Expand') }}</span>
                <template v-for="key in hotKeyMap.collapes">
                    <span :key="`collapes-${key}-tooltip-tip`" class="patent-list-toggle__tooltip-tip">{{ key }}</span>
                    <span :key="`collapes-${key}-tooltip-and`" class="patent-list-toggle__tooltip-and">+</span>
                </template>
            </div>
        </ELTooltip>
    </ul>
</template>

<script>
import { Icon } from 'patsnap-biz';
import { Tooltip } from 'element-ui';
import { patentListHotKeyKeyboardValMap } from '../../../utils/hotKeys';
import { POPPER_OPEN_DELAY } from '../../../constants';
import addIframe from '../../../directives/addIframe';
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg';
import '@patsnap-ui/icon/assets/solid/ArrowDown.svg';
import '@patsnap-ui/icon/assets/solid/DropdownRight.svg';
import '@patsnap-ui/icon/assets/solid/DropdownLeft.svg';

export default {
    name: 'PatentListToggle',
    directives: {
        addIframe,
    },
    components: {
        PtIcon: Icon,
        ELTooltip: Tooltip,
    },
    props: {
        disablePre: {
            type: Boolean,
            default: false,
        },
        disableNext: {
            type: Boolean,
            default: false,
        },
        disableCollapes: {
            type: Boolean,
            default: false,
        },
        isCollapsed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hotKeyMap: patentListHotKeyKeyboardValMap,
        };
    },
    created() {
        this.popperOpenDelay = POPPER_OPEN_DELAY;
    },
    methods: {
        togglePre() {
            if (this.disablePre) return;
            this.$emit('toggle', 'pre');
        },
        toggleNext() {
            if (this.disableNext) return;
            this.$emit('toggle', 'next');
        },
        toggleCollapes() {
            if (this.disableCollapes) return;
            this.$emit('toggle', 'collapes');
            // Fixme 收缩tooltip不消失 先调用api强行关闭
            if (this.$refs.patentsListCollapes) {
                this.$refs.patentsListCollapes.hide();
            }
        },
    },
};
</script>

<style lang="scss">
.patent-list-toggle {
    margin: 0;
    padding: 0;
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    z-index: 9;

    &__item {
        width: 18px;
        height: 24px;
        line-height: 24px;
        box-shadow: inset 1px 0 0 0 #dfe6ec;
        background-color: $white;
        cursor: pointer;
        text-align: center;
        position: relative;
        overflow: hidden;
        &:hover {
            background-color: $neutral-blue-30;
        }
        &:first-child {
            border-radius: 4px 0 0 0;
            box-shadow: inset 1px 0 0 0 #dfe6ec, inset 0 1px 0 0 #dfe6ec;
        }
        &:last-child {
            border-radius: 0 0 0 4px;
            box-shadow: inset 0 -1px 0 0 #dfe6ec, inset 1px 0 0 0 #dfe6ec;
        }
        &--disabled {
            background-color: $white !important;
            cursor: not-allowed;
            .patsnap-biz-icon {
                color: $neutral-blue-60 !important;
            }
        }
        .patsnap-biz-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
        }
        .patsnap-biz-icon[icon^="SolidArrow"]{
            font-size: 16px;
        }
        .patsnap-biz-icon[icon^="SolidDropdown"]{
            font-size: 20px;
        }
    }

    &__tooltip {
        &::after {
            content: '';
            height: 0;
            line-height: 0;
            display: block;
            visibility: hidden;
            clear: both;
        }
        &-text, &-tip, &-and {
            font-size: 14px;
            line-height: 20px;
            display: inline-block;
            float: left;
        }
        &-text {
            margin-right: 8px;
        }
        &-tip {
            min-width: 20px;
            text-align: center;
            padding: 0 4px;
            border-radius: 2px;
            background-color: $neutral-blue-200;
        }
        &-and {
            margin: 0 2px;
            &:last-of-type{
                display: none;
            }
        }
    }
}
.patent-list-toggle__tooltip-container {
    padding: 0 !important;
    .patent-list-toggle__tooltip {
        position: relative;
        padding: 8px;
        border-radius: 4px;
    }
}
</style>
